import layoutStyle from "./../App/layout.scss";
import style from "./index.scss";
import { trim } from "lodash";

export const getFormErrorData = (state, isValid = true) => {
  const formError = {};
  Object.keys(state.formError).forEach((key) => {
    const obj = Object.assign({}, state.formError[key]);
    if (trim(state[key])) {
      obj.isError = false;
    } else {
      obj.isError = true;
      isValid = false;
    }
    formError[key] = obj;
  });
  return { formError, isValid };
};

export const PrioritySelect = ({ inputName, handleChange, options }) => {
  return (
    <div class={style.prioritySelect}>
      <label>Prioritize this ticket</label>
      <select
        value={inputName}
        onChange={handleChange}
        onKeyPress={(e) => {
          if (e.keyCode === 13) e.preventDefault();
        }}
        name="priority"
      >
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export const HubSelect = ({ inputName, handleChange, options }) => {
  return (
    <div class={style.hubSelect}>
      <label>Please select the platform this question is about</label>
      <p class={layoutStyle.inputExtraText}>
        If it's unrelated to any of these hubs, just select your default hub.
      </p>
      <select
        value={inputName}
        onChange={handleChange}
        onKeyPress={(e) => {
          if (e.keyCode === 13) e.preventDefault();
        }}
        name="hub"
      >
        {options.map((option, index) => (
          <option key={index} value={option.id}>
            {option.name.toUpperCase()}
          </option>
        ))}
      </select>
    </div>
  );
};

export const BetaTestCheckbox = ({ inputName, handleChange }) => (
  <div class={style.betaTestCheckbox}>
    <input
      type="checkbox"
      id="confirmField"
      checked={inputName}
      onChange={handleChange}
      onKeyPress={(e) => {
        if (e.keyCode === 13) handleChange(e);
      }}
      name="inBetaTesting"
    />
    <label class="label-inline" for="confirmField">
      Is this ticket related to a feature you’re beta testing?
    </label>
  </div>
);

export const FormButton = ({
  onContentClick,
  handleSubmit,
  submitButtonName = "SUBMIT",
  backButtonName = "BACK",
  isSubmitButtonDisable = false,
  isBackButton = true,
}) => (
  <div class="cleafix">
    {isBackButton ? (
      <button
        onClick={() => onContentClick("Home")}
        class={style.formButton + " " + style.backButton}
      >
        {backButtonName}
      </button>
    ) : null}
    <button
      type="submit"
      onClick={(e) => handleSubmit(e)}
      class={"button " + style.formButton + " " + style.submitButton}
      disabled={isSubmitButtonDisable}
    >
      {submitButtonName}
    </button>
  </div>
);

export const ErrorText = () => (
  <div class={layoutStyle.errorFieldText}>This field is required.</div>
);

export const Button = ({ children, onClick, type, className = "" }) => {
  return (
    <button
      onClick={onClick}
      className={`${style.button} ${
        type === "secondary" && style.secondary
      } ${className}`}
    >
      {children || "Submit"}
    </button>
  );
};



// WEBPACK FOOTER //
// ./components/Helpers/index.js